const Helpers = {
  formatDate: function (dateStr) {
    let date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  },
  callApi: function (url, params) {
    return axios
      .get(url, {
        params: params,
      })
      .catch((error) => {
        if (error.response.status == 404) {
          // Se l'errore è 404, ritorna un intero 404 nell'oggetto data
          return { data: 404 };
        }

        // Gestisci l'errore in modo appropriato
        console.error(error);
        alert("Si è verificato un errore durante il recupero dei dati.");
      });
  },
  openImageInDialog: function (imageUrl) {
    var zoomedImg = document.getElementById("zoomedImg");
    zoomedImg.src = imageUrl;
    document.getElementById("imageDialog").showModal();
  },

  closeDialog: function () {
    document.getElementById("imageDialog").close();
  },
};

window.Helpers = Helpers;
